module.exports = __webpack_public_path__ + "static/media/as6cr93.a8acde39.png";